module.exports = __webpack_public_path__ + "img/curved11.de38324b.jpg";